<template>
	<div class="report">
		<div class="d-flex breif">
			<div v-if="data.image" class="cover" :style="{ backgroundImage: `url(${data.image})` }"></div>
			<div class="d-flex__item d-flex d-flex--column" style="justify-content: space-between;">
				<div class="product_title">{{ data.productName }}</div>
				<div class="mt-20">
					<span class="narrator-title mr-40">{{ data.user_name }}</span>
				</div>
				<div class="time">
					{{ data.num }}个讲解点 时长{{ data.time }}分钟
					<!-- <span class="ml-10">讲解{{ data.num }}条</span> -->
				</div>
			</div>
		</div>

		<!-- <div class="info">
			<div class="exp-title">讲解指南</div>
			<div v-html="data.productName"></div>
		</div> -->
		
		
		<div class="blocks">
			<div class="block" v-for="(dot, index1) in data.list" :key="'d13'+dot.id">
				<Item :product="data" :active="currentAudio === dot.id" @exp-end="handleExpEnd" @play="handlePlay"
					@play-complete="handlePlayComplete(index1, 0)" @goPlayer="goPlayer" :index1="index1" :index2="0"
					:key="'d4-'+dot.id" :data="dot" :is_buy="data.is_buy" :is_try="data.is_try"/>
			</div>
		</div>
		
		<template v-if="!hasBuy">
			<div class="d-flex d-flex--middle footer">
				<div class="d-flex__item buy" @click="isBuy = true">
					<span>￥{{ data.price }}</span>
					<span class="btn">立即购买</span>
				</div>
			</div>
			<ScrollComment v-if="commentList.length" :data="commentList" class="fixed-cm" />
			<BuyModal :price="data.price" :visible.sync="isBuy" :data="data" />
		</template>



		<div class="back-play" style="bottom:140px" @click="bnShow=true" v-if="currentAudio">
			后台
		</div>
		<div class="back-play" @click="viewDot(currentAudio, false)" v-if="currentAudio">
			回到
		</div>
		<FullRouterView />
		<ExpModal @buy="isBuy = true" :num="numAudio" :data="data" :user="data" :visible.sync="isExp" />


		<div v-if="bnShow" class="banner">
			<div class="con">
				<div class="imgs">
					<img :src="item" :class="'pic'+(index+1)" v-for="(item,index) in bnimg" :key="index"/>
				</div>
			</div>
			<div class="close" @click="bnShow=false">关闭提示</div>
		</div>
		<popup v-model="isVideoPlay">
			<div class="video-content">

				<!-- <video playsinline="true" webkit-playsinline="true"  x5-playsinline="true" 
					x5-video-player-type="h5" x5-video-player-fullscreen="true" x5-video-orientation="portrait"
					:src="videoUrl" controls="controls" controlsList="nodownload" disablePictureInPicture /> -->
				<div class="my_video">
					<video-player id="videoDiv" class="video-player vjs-custom-skin" ref="videoPlayer"
						:playsinline="true" :webkit-playsinline="true" :options="videoPlayerOptions"
						@play="onPlayerPlay($event)" @pause="onPlayerPause($event)" @ended="onPlayerEnded($event)"
						@waiting="onPlayerWaiting($event)" @playing="onPlayerPlaying($event)"
						@loadeddata="onPlayerLoadeddata($event)" @timeupdate="onPlayerTimeupdate($event)"
						@canplay="onPlayerCanplay($event)" @canplaythrough="onPlayerCanplaythrough($event)"
						@statechanged="playerStateChanged($event)" @ready="playerReadied">
					</video-player>

				</div>

				<vue-core-video-player v-if="false" ref="myVideo" @ended="ended" @loadeddata="loadeddata"
					:src="videoUrl">
				</vue-core-video-player>
			</div>
		</popup>


	</div>
</template>

<script>
	import Item from "./item";
	import Modax from "modax";
	import {
		mixin
	} from "@/components/Explain";
	import BuyModal from "./buy";
	import {
		scrollTo
	} from "@/utils";
	// import MakeComment from "./make-comment";
	import FullRouterView from "@/components/FullRouterView";
	import ExpModal from "./exp-end";
	// import VideoPlayerIndex from "./VideoPlayerIndex"
	import Popup from "../../components/popup.vue"
	// import { CURRENT } from "./player";
	export default {
		components: {
			Item,
			BuyModal,
			FullRouterView,
			ExpModal,
			// VideoPlayerIndex,
			Popup,
		},
		mixins: [mixin],
		data() {
			return {
				fileType: 'mp4', // 资源的类型
				videoUrl: 'https://hanchao-app.oss-cn-beijing.aliyuncs.com/1626330100640.mp4', // 资源的路径地址
				posterUrl: '', //封面地址
				info: {},
				currentAudio: 0,
				isBuy: false,
				isShowShare: false,
				isExp: false,
				isVideoPlay: false,
				PlayingInfo: null,
				bnimg: [],
				bnShow: false,
			};
		},
		// beforeRouteLeave(to, from, next) {
		//   try {
		//     CURRENT.stop();
		//   } catch {
		//     //
		//   }
		//   next();
		// },
		computed: {
			videoPlayerOptions() {
				const videoPlayerOptions = {
					playbackRates: [0.75, 1.0, 1.25, 1.5, 2.0], //播放速度
					autoplay: false, // 是否自动播放。
					muted: false, // 是否静音播放，默认情况下将会消除任何音频。
					loop: false, // 是否循环播放。
					preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
					language: 'zh-CN',
					// aspectRatio: '3:1', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
					// fluid: true, // 是否流体从而按比例缩放以适应其容器。
					flash: {
						hls: {
							withCreadentials: false
						}
					}, //可以播放rtmp视频
					html5: {
						hls: {
							withCreadentials: false
						}
					}, //可以播放m3u8视频
					sources: [{
						type: 'video/' + this.fileType,
						src: this.videoUrl // 视频url地址
					}],
					poster: this.posterUrl, // 封面地址
					width: '100%',
					notSupportedMessage: '此视频暂无法播放...', // 当无法播放时允许覆盖Video.js，显示的默认信息。
					controlBar: {
						timeDivider: true,
						durationDisplay: true,
						remainingTimeDisplay: false,
						fullscreenToggle: true
					}
				}
				return videoPlayerOptions
			},
			hasBuy() {
				try {
					return this.info.is_buy;
				} catch {
					return 0;
				}
			},
			star() {
				try {
					return +this.info.productDetails.hcScenicNarrator.score / 2;
				} catch {
					return 0;
				}
			},
			numAudio() {
				return this.audioList.reduce((a, b) => {
					return a;
				}, 0);
			},
			audioList() {
				return this.info.list || [];
			},
			commentList() {
				return (this.info.orderEvaluates || []).filter((o) => !!o.userName);
			},
			commentListMini() {
				return this.commentList.slice(0, 3);
			},
			data() {
				return this.info || {};
			},
			dots() {
				const arr = this.info.objectAudioParagraphs || [];
				if (!arr.length) {
					return [];
				}
				return arr.reduce((a, b) => {
					if (+b.type === 1) {
						a.push({
							...b,
							children: [],
						});
					} else {
						a[a.length - 1].children.push(b);
					}
					return a;
				}, []);
			},
		},

		mounted() {
			this.isEquipment()
			this.getInfo();
			this.getBn()

			this.pushHistory();
			// let that = this;
			//延时监听防止页面刷新时被触发
			window.addEventListener("popstate", this.backChange, false);

		},
		destroyed() {
			window.removeEventListener('popstate', this.backChange, false); // false阻止默认事件
		},
		methods: {
			isEquipment(){
				let UA = navigator.userAgent,
					isAndroid = /android|adr|linux/gi.test(UA),
					isIOS = /iphone|ipod|ipad/gi.test(UA) && !isAndroid;
				if(isAndroid){
					this.isAndroid = isAndroid;
					this.$router.push({
						name: "Toxcx"
					});
				}
			},
			getBn(){
				this.$http.post("/wx/MoreImages", {
					jid: localStorage.getItem("jid"),
					memberId: this.$store.state.user.id,
					productId: this.$route.params.id,
				}).then(res=>{
					this.bnimg = res
				});
			},
			pushHistory() {
				var state = {
					title: "title",
					url: ""
				};
				window.history.pushState(state, "title", "");

			},
			// 播放回调
			onPlayerPlay(player) {
				//console.log('player play!', player)
			},

			// 暂停回调
			onPlayerPause(player) {
				//console.log('player pause!', player)
			},

			// 视频播完回调
			onPlayerEnded($event) {
				this.$refs.videoPlayer.player.src(this.fileUrl);
				this.goBack();
				if (this.PlayingInfo) {
					console.log('this.PlayingInfo' + this.PlayingInfo.isCharge + "----");
					if (this.PlayingInfo.isCharge == 0 && !this.info.productDetails.validity) {
						this.handleExpEnd(); //显示试听结束购买视频
					}
				}

			},

			// DOM元素上的readyState更改导致播放停止
			onPlayerWaiting($event) {
				//console.log(player)
			},

			// 已开始播放回调
			onPlayerPlaying($event) {
				// console.log(player)
				Modax.close("player");
			},

			// 当播放器在当前播放位置下载数据时触发
			onPlayerLoadeddata($event) {
				// console.log(player)
			},

			// 当前播放位置发生变化时触发。
			onPlayerTimeupdate($event) {
				//console.log(player)
			},

			//媒体的readyState为HAVE_FUTURE_DATA或更高
			onPlayerCanplay(player) {
				// console.log('player Canplay!', player)
			},

			//媒体的readyState为HAVE_ENOUGH_DATA或更高。这意味着可以在不缓冲的情况下播放整个媒体文件。
			onPlayerCanplaythrough(player) {
				// console.log('player Canplaythrough!', player)
			},

			//播放状态改变回调
			playerStateChanged(playerCurrentState) {
				//console.log('player current update state', playerCurrentState)
			},

			//将侦听器绑定到组件的就绪状态。与事件监听器的不同之处在于，如果ready事件已经发生，它将立即触发该函数。。
			playerReadied(player) {
				//console.log('example player 1 readied', player);
			},
			//视频播放结束
			ended() {
				this.goBack();
			},
			// 播放回调
			loadeddata() {
				// this.isShow = true;
			},
			backChange() {
				Modax()
					.width("80%")
					.title("提示")
					.content("是否要退出当前页面?")
					.cancel(true)
					.ok("确定退出")
					.ok(() => {
						this.goBack();
						this.$router.replace({
							path: '/'
						});
						return true;
					})
					.show();
			},
			goBack() {
				this.isVideoPlay = false;
			},
			isIos() {
				const u = navigator.userAgent;
				return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
			},
			closeVideoPlayer(isVideoPlay) {
				this.isVideoPlay = isVideoPlay;
				console.log("播放器关闭")
			},
			goPlayer(data) {
				console.log(data)
				// Modax("player")
				// 	.loading()
				// 	.title("缓冲中...")
				// 	.show();
				// console.log("地址" + JSON.stringify(data) + "this.isVideoPlay" + this.isVideoPlay);
				// console.log("index1"+data.index1,"index2"+data.index2)
				this.PlayingInfo = data;
				this.videoUrl = data.saveurl;
				this.isVideoPlay = true;
				this.currentAudio = data.id;
				let that = this;
				setTimeout(function() {
					that.$nextTick(function() {
						that.$refs.videoPlayer.player.play();
					})

				}, 500);
				
				// this.handlePlayComplete(data.index1,data.index2);
				

			},
			handleExpEnd() {
				this.isExp = true;
			},
			toggleShare() {
				this.isShowShare = !this.isShowShare;
			},
			viewDot(id, toggle = true, triggerByUser = true) {
				if (this.$refs["dot" + id]) {
					const dom = this.$refs["dot" + id][0];
					let t = dom.offsetTop;
					let p = dom.parentElement;
					while (p !== document.body) {
						t = Math.max(p.offsetTop, t);
						p = p.parentElement;
					}
					// scrollTo(t - 100);
					return;
				}
				this.$root.$emit("view-dot", {
					id,
					toggle,
					triggerByUser
				});
			},
			handlePlay(id) {
				this.currentAudio = id;
			},
			handlePlayComplete(index1, index2) {
				console.log(this.audioList[index1])
				const audioList = this.audioList[index1];
				const nextAudio = audioList[index2 + 1];
				const nextBlock = this.audioList[index1 + 1];
				if (nextAudio) {

					return this.viewDot(nextAudio.id, true, false);
				} else {
					if (nextBlock) {

						return this.viewDot(
							nextBlock.id,
							true,
							false
						);
					}
				}
			},
			async getInfo() {
				this.info = await this.$http.post("/wx/WeiXinProductDetail", {
					jid: localStorage.getItem("jid"),
					jd_top: localStorage.getItem('jd_top') || "",
					memberId: this.$store.state.user.id,
					productId: this.$route.params.id,
				});
			},
		},
	};
</script>

<style lang="scss" scoped>
	.video-content {
		height: 100vh;
		width: 100vw;
		// padding-bottom: 10px;
	}
	.banner{
		width: 100vw;
		height: 100vh;
		background: #0009;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 999;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		.con{
			width: 60vw;
			height: 100vw;
			margin: 6vw 20vw;
			overflow: hidden;
			position: relative;
			.imgs{
				display: flex;
				width: 180vw;
				height: 100vw;
				position: absolute;
				top: 0;
				left: 0;
				animation: bannerMove 12s infinite;
				@keyframes bannerMove {
					0%,30%{left: 0;}
					35%,65%{left: -100%; }
					70%,99%{left: -200%; }
					100%{left: 0; }
				}
				img{
					width: 60vw;
				}
			}
		}
		.close{
			background: #fff;
			padding: 0 4vw;
			font-size: 4vw;
			line-height: 10vw;
			border-radius: 5vw;
		}
	}
	.footer {
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		height: 96px;
		background: #fff;
		padding: 0 24px;
		z-index: 50;
		border-top: solid 1px #ddd;
		white-space: nowrap;
		line-height: 1;
		overflow: hidden;

		.buy-info {
			color: #666;
			font-size: 28px;
			white-space: nowrap;
			position: relative;
			padding-right: 20px;

			&::v-deep {
				.star {
					width: 20px;
					height: 20px;
				}
			}

			&::after {
				position: absolute;
				content: "";
				background: #ddd;
				top: -20px;
				width: 1px;
				bottom: -20px;
				right: 0;
			}
		}

		.buy {
			text-align: right;
			font-size: 32px;
			font-weight: bold;
			color: #333;

			.btn {
				background: $detail-pay-btn; //c7614c
				font-size: 32px;
				padding: 10px 20px;
				border-radius: 30px;
				color: #fff;
				margin-left: 20px;
			}
		}
	}

	.comment-list {
		background: #fffcf8;

		// margin: 30px;
		padding: 30px 50px;
		margin-top: 0;

		.c-list {
			background: #f6f5ef;
		}

		.summary {
			position: relative;
			padding-bottom: 30px;

			&::after {
				@include border-bottom-1;
			}
		}

		.view-all {
			font-size: 28px;
			color: #666;
			font-weight: 500;
		}
	}

	.report {
		padding-bottom: 100px;
	}

	.score {
		font-weight: 800;
	}

	.exp-title {
		font-size: 32px;
		font-weight: 500;
		margin-bottom: 30px;
	}

	.blocks {
	}

	.block {
		padding: 0 30px 0;
		margin-top: 30px;
		&:first-child {
			.block-title-small {
				padding-top: 40px;
			}
		}
	}

	.block {
		&:first-child {
			.block-title {
				padding-top: 30px;
			}
		}
	}

	.block-title {
		font-size: 36px;
		font-weight: bold;
		color: $detail-explain-title-color; //c7614c
	}

	.block-title-small {
		color: #e3a221;
		margin-left: 10px;
		padding-top: 10px;
	}

	.breif,
	.info {
		position: relative;
		padding-bottom: 40px;
		background: #fff;
		padding: 30px;

		&::after {
			@include border-bottom-1;
			transform: none;
			//prettier-ignore
			height: 1PX;
			background: #ddd;
			left: 30px;
			right: 30px;
		}
	}

	.breif {
		margin-bottom: 0;

		.title {
			font-size: 32px;
			font-weight: bold;
		}

		.narrator-title {
			font-size: 28px;
		}

		.product_title {
			font-size: 32px;
			font-weight: bold;
		}

		.time {
			color: #666666;
		}
	}

	.view-comment {
		display: flex;
		justify-content: space-between;
		background: #fff;
		padding: 30px;
		align-items: center;
		margin-bottom: 30px;

		&:active {
			background: darken($color: #fff, $amount: 3);
		}

		&::after {
			display: inline-block;
			width: 20px;
			height: 20px;
			border: solid 1px #ddd;
			border-color: transparent transparent #bbb #bbb;
			transform: rotate(-135deg);
			content: "";
		}
	}

	.cover {
		width: 180px;
		height: 220px;
		border-radius: 4px;
		background: #ccc no-repeat center;
		background-size: cover;
		margin-right: 30px;
	}

	.list {
		background: #fffcf8;

		padding: 30px;
		position: sticky;
		top: 0;
		z-index: 15;
	}

	.nav {
		white-space: nowrap;
		overflow: auto;
		overflow-y: hidden;
		-webkit-overflow-scrolling: touch;
		padding: 0 10px;
		padding-bottom: 10px;

		&::after {
			@include border-bottom-1;
			background: #ddd;
			transform: none;
		}

		.nav-item {
			display: inline-block;
			font-size: 0;

			&:last-child {
				.split:last-of-type {
					display: none;
				}
			}

			.split {
				display: inline-block;
				height: 1px;
				background: #ddd;
				width: 100px;
				position: relative;
				transform: translateZ(0);

				&::after,
				&::before {
					content: "";
					position: absolute;
					left: calc(50% - 6px);
					top: 0;
					width: 8px;
					height: 8px;
					top: -2px;
					border: solid 1px #ddd;
					transform-origin: center;
					transform: rotate(45deg) translateZ(0);
					background: #fffcf8;
					z-index: 2;
				}

				&::before {
					transform: scale(2) translateZ(0);
					border: none;
					z-index: 1;
				}
			}

			.lev1,
			.lev2 {
				color: #aa4f1b; //aa4f1b
				font-size: 24px;
				display: inline-flex;
				align-items: center;
				justify-content: center;
				vertical-align: middle;
				text-align: center;
				line-height: 100px;
				width: 100px;
				height: 100px;
				border-radius: 100px;
				border: solid 1px #c7614c; //#c7614c
				background: #fff;
				margin: 0;
				position: relative;
				transform: scale(0.9) translateZ(0);
				white-space: normal;
				word-break: break-all;

				span {
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					overflow: hidden;
					text-overflow: ellipsis;
					line-height: 1.2;
					width: 70%;
				}

				&.active {
					background: #c7614c;
					color: #fff;
				}
			}

			.lev1 {
				position: relative;
				border: none;
				width: 120px;
				height: 120px;
				line-height: 120px;

				&+.split {
					margin-left: -5px;
				}

				span {
					position: relative;
					z-index: 2;
				}
			}

			.lev2 {
				//prettier-ignore
				border-width: 2Px;
			}

			.bub {
				position: absolute;
				left: 0;
				top: 0;
				width: 100%;
				height: 100%;
				transform: translateY(5px);

				path {
					fill: $detail-path-title-color; //f2d45c
				}
			}
		}
	}

	.back-play {
		display: inline-block;
		width: 90px;
		height: 90px;
		background: rgba(163, 55, 55, 1);
		box-shadow: 0px 5px 10px 0px rgba(168, 65, 65, 0.8);
		opacity: 0.95;
		border-radius: 50%;
		color: #fff;
		position: fixed;
		bottom: 160px;
		right: 30px;
		z-index: 10;
		display: flex;
		align-items: center;
		flex-direction: column;
		line-height: 1.2;
		justify-content: center;
		font-size: 24px;

		&::after {
			content: "播放";
			display: block;
		}
	}

	.go-home {
		background: rgba($color: #a6a4a1, $alpha: 0.9);
		position: fixed;
		right: 0;
		top: 20px;
		color: #fff;
		z-index: 200;
		padding: 10px;
		padding: 0 20px;
		border-radius: 30px 0 0 30px;

		&.back {
			top: 180px;
		}

		&.share {
			top: 100px;
		}
	}

	.fixed-cm {
		position: fixed;
		left: 10px;
		bottom: 100px;
		z-index: 500;
	}

	.share-tip {
		position: fixed;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.6) url(~@/assets/share.png) no-repeat;
		background-position: right top;
		background-size: 200px;
		z-index: 99999;
		color: #fff;
		text-align: center;
		padding-top: 200px;
		font-size: 32px;
		font-weight: 500;
	}
</style>
